module.exports = __webpack_public_path__ + "static/media/stock09.5273bd5d.jpg";